import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RecuperarSenhaComponent } from './recuperar-senha.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: RecuperarSenhaComponent }
    ])],
    exports: [RouterModule]
})
export class RecuperarSenhaRoutingModule { }